module.exports = __webpack_public_path__ + "img/xpu-ha-pool-3.b204a515.jpg";